(function () {
  /* Textes dépliants */
  document.addEventListener("click", function (event) {
    const moreButton = event.target.closest(".product-description-more");
    const lessButton = event.target.closest(".product-description-less");
    const showMoreButton = event.target.closest(".js-show-more");

    if (moreButton) {
      event.preventDefault();

      const shortText = moreButton.closest(".product-description-short");
      const fullText = shortText
        ? shortText.nextElementSibling
        : null;

      if (shortText) shortText.style.display = "none";
      if (fullText) fullText.style.display = "block";
    }

    if (lessButton) {
      event.preventDefault();

      const fullText = lessButton.closest(".product-description-full");
      const shortText = fullText
        ? fullText.previousElementSibling
        : null;

      if (fullText) fullText.style.display = "none";
      if (shortText) shortText.style.display = "block";
    }

    if (showMoreButton) {
      event.preventDefault();

      const parent = showMoreButton.parentElement;

      if (parent) {
        parent
          .querySelectorAll("input, label")
          .forEach(function (element) {
            element.classList.remove("hidden");
          });
      }

      showMoreButton.remove();
    }
  });
})();

/* ==========================================
   FORMULAIRE FLOTTANT PRODUIT
   ========================================== */

if (!customElements.get("floated-form")) {
  class FloatedForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === "true") return;

      this.dataset.initialized = "true";
      this.loadProductForm();
    }

    disconnectedCallback() {
      this.destroyVisibilityEvents();
    }

    async loadProductForm() {
      const productUrl = this.dataset.productUrl;

      if (!productUrl) {
        console.warn("Floated form : URL produit absente.");
        return;
      }

      try {
        const response = await fetch(productUrl);

        if (!response.ok) {
          throw new Error("Erreur HTTP " + response.status);
        }

        const htmlText = await response.text();

        const documentHTML = new DOMParser().parseFromString(
          htmlText,
          "text/html"
        );

        const productInfo = documentHTML.querySelector(
          'div[id^="ProductInfo-"]'
        );

        if (!productInfo) {
          console.warn("Floated form : ProductInfo introuvable.");
          return;
        }

        const productImage =
          documentHTML.querySelector(
            ".product__media-wrapper--mobile .product__media img"
          ) ||
          documentHTML.querySelector(
            ".product__media-wrapper .product__media img"
          );

        this.prepareProductInfo(productInfo);
        this.innerHTML = productInfo.innerHTML;

        this.executeInsertedScripts();
        this.createProductSummary(productImage);
        this.identifyUsefulBlocks();
        this.removeRemainingUselessBlocks();

        this.dataset.loaded = "true";

        this.initializeShopifyFeatures();
        this.initializeVisibility();
      } catch (error) {
        console.error(
          "Impossible de charger la barre flottante :",
          error
        );
      }
    }

    prepareProductInfo(productInfo) {
      const sectionId = productInfo.dataset.section;

      if (sectionId) {
        productInfo.innerHTML = productInfo.innerHTML.replaceAll(
          sectionId,
          "floated-" + sectionId
        );

        productInfo
          .querySelectorAll("variant-selects, variant-radios")
          .forEach(function (picker) {
            picker.dataset.originalSection = sectionId;
          });
      }

      const selectorsToRemove = [
        ".product__text",
        ".share-buttons",
        ".rating",
        ".product-tags",
        ".product__description",
        ".advantage",
        ".note",
        ".promo-banner",
        "pickup-availability",
        "product-modal",
        "floated-form",
        "related-product",
        ".customer",
        ".custom-liquid",
        ".app-block-wrapper",
        ".mp-quote-widget",
        ".installment-wrapper"
      ];

      selectorsToRemove.forEach(function (selector) {
        productInfo
          .querySelectorAll(selector)
          .forEach(function (element) {
            element.remove();
          });
      });
    }

    executeInsertedScripts() {
      this.querySelectorAll("script").forEach(function (oldScript) {
        const newScript = document.createElement("script");

        Array.from(oldScript.attributes).forEach(function (attribute) {
          newScript.setAttribute(
            attribute.name,
            attribute.value
          );
        });

        newScript.textContent = oldScript.textContent;
        oldScript.replaceWith(newScript);
      });
    }

    createProductSummary(productImage) {
      const originalTitle = this.querySelector(".product__title");
      const originalPrice = this.querySelector(".price-wrapper");

      const summary = document.createElement("div");
      summary.className = "mp-floated-product";

      if (productImage) {
        const imageContainer = document.createElement("div");
        imageContainer.className = "mp-floated-product__image";

        const image = productImage.cloneNode(true);

        image.removeAttribute("id");
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.removeAttribute("loading");

        imageContainer.appendChild(image);
        summary.appendChild(imageContainer);
      }

      const information = document.createElement("div");
      information.className = "mp-floated-product__content";

      const title = document.createElement("div");
      title.className = "mp-floated-product__title";
      title.textContent = originalTitle
        ? originalTitle.textContent.trim()
        : "";

      const price = document.createElement("div");
      price.className = "mp-floated-product__price";

      if (originalPrice) {
        const priceClone = originalPrice.cloneNode(true);

        priceClone.removeAttribute("id");

        priceClone
          .querySelectorAll("[id]")
          .forEach(function (element) {
            element.removeAttribute("id");
          });

        price.appendChild(priceClone);
      }

      information.appendChild(title);
      information.appendChild(price);

      summary.appendChild(information);
      this.prepend(summary);
    }

    identifyUsefulBlocks() {
      const variantElement =
        this.querySelector("variant-selects") ||
        this.querySelector("variant-radios") ||
        this.querySelector(".product-parameters");

      const purchaseElement =
        this.querySelector("product-form") ||
        this.querySelector(".product-form");

      const directChildren = Array.from(this.children);

      const variantBlock = directChildren.find(function (child) {
        return (
          child === variantElement ||
          (variantElement && child.contains(variantElement))
        );
      });

      const purchaseBlock = directChildren.find(function (child) {
        return (
          child === purchaseElement ||
          (purchaseElement && child.contains(purchaseElement))
        );
      });

      if (variantBlock) {
        variantBlock.classList.add("mp-floated-variants");
      }

      if (purchaseBlock) {
        purchaseBlock.classList.add("mp-floated-buy");
      }
    }

    removeRemainingUselessBlocks() {
      Array.from(this.children).forEach(function (child) {
        const useful =
          child.classList.contains("mp-floated-product") ||
          child.classList.contains("mp-floated-variants") ||
          child.classList.contains("mp-floated-buy");

        if (!useful) {
          child.remove();
        }
      });
    }

    initializeShopifyFeatures() {
      if (
        window.Shopify &&
        window.Shopify.PaymentButton
      ) {
        window.Shopify.PaymentButton.init();
      }

      if (
        window.ProductModel &&
        typeof window.ProductModel.loadShopifyXR === "function"
      ) {
        window.ProductModel.loadShopifyXR();
      }
    }

    findOriginalAddButton() {
      const productSection = this.closest(
        'section[id^="MainProduct-"]'
      );

      if (!productSection) return null;

      return Array.from(
        productSection.querySelectorAll(
          ".product-form__submit"
        )
      ).find(function (button) {
        return !button.closest("floated-form");
      }) || null;
    }

    initializeVisibility() {
      this.destroyVisibilityEvents();

      const originalButton = this.findOriginalAddButton();

      this.visibilityHandler = () => {
        let shouldDisplay = window.scrollY > 450;

        if (originalButton) {
          const buttonRectangle =
            originalButton.getBoundingClientRect();

          shouldDisplay =
            buttonRectangle.bottom < 0;
        }

        this.classList.toggle(
          "mp-floated-visible",
          shouldDisplay
        );

        this.setAttribute(
          "aria-hidden",
          shouldDisplay ? "false" : "true"
        );
      };

      window.addEventListener(
        "scroll",
        this.visibilityHandler,
        { passive: true }
      );

      window.addEventListener(
        "resize",
        this.visibilityHandler
      );

      window.addEventListener(
        "orientationchange",
        this.visibilityHandler
      );

      this.visibilityHandler();
    }

    destroyVisibilityEvents() {
      if (!this.visibilityHandler) return;

      window.removeEventListener(
        "scroll",
        this.visibilityHandler
      );

      window.removeEventListener(
        "resize",
        this.visibilityHandler
      );

      window.removeEventListener(
        "orientationchange",
        this.visibilityHandler
      );

      this.visibilityHandler = null;
    }
  }

  customElements.define("floated-form", FloatedForm);
}